import React from 'react';

type IconProps = {
  icon: React.ElementType; // UntitledUI icon component
  size?: number | string; // override default size
  color?: string; // override default color
  className?: string;
  title?: string; // tooltip text
};

export function Icon({ icon: IconComponent, size, color, className, title }: IconProps) {
  const icon = (
    <IconComponent
      style={{
        width: size || 'var(--icon-size)',
        height: size || 'var(--icon-size)',
        color: color || 'var(--icon-color-primary)'
      }}
      className={className}
    />
  );

  if (title) {
    return (
      <span title={title} style={{ display: 'inline-flex', alignItems: 'center' }}>
        {icon}
      </span>
    );
  }

  return icon;
}
